var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 452 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.21,324.9c-3.02-.98-6.33-.09-8.45,2.28l-92.75,103.41-92.76-103.41c-2.12-2.36-5.43-3.25-8.45-2.28C26.08,356.96,0,439.08,0,478.03c0,10.58,3.23,19.01,9.59,25.07,8.62,8.21,19.88,8.91,23.46,8.91.32,0,.58,0,.77-.01h384.35c.19,0,.45.01.77.01,3.58,0,14.84-.7,23.46-8.9,6.36-6.06,9.59-14.49,9.59-25.07,0-38.94-26.08-121.07-124.79-153.12ZM33.67,495.94c-.09,0-.24,0-.33,0-.08,0-7.84.2-12.76-4.55-3.01-2.91-4.53-7.41-4.53-13.37,0-.99,1.27-98.41,108.78-136.2l93.15,103.84v50.27H33.67ZM431.42,491.4c-4.9,4.74-12.66,4.55-12.69,4.55-.13,0-.26,0-.39,0h-184.31v-50.27l93.15-103.84c107.51,37.79,108.78,135.2,108.78,136.2,0,5.96-1.52,10.46-4.53,13.37Z",
    fill: "#7f7f7f",
    stroke: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03,271.84h66.29c2.63,0,5.09-1.29,6.59-3.45,1.5-2.16,1.85-4.92.93-7.38l-32.64-87.53v-85.17l174.41,54.51c.78.24,1.59.37,2.39.37s1.61-.12,2.39-.37l203.42-63.57c3.35-1.05,5.63-4.15,5.63-7.66s-2.28-6.61-5.63-7.66L228.4.36c-1.56-.49-3.23-.49-4.79,0L20.18,63.94c-3.35,1.05-5.63,4.15-5.63,7.66s2.28,6.61,5.63,7.66l12.96,4.05v90.18L.51,261.02c-.92,2.46-.57,5.22.93,7.38,1.5,2.16,3.96,3.45,6.59,3.45ZM226,16.43l176.53,55.17-176.53,55.17L49.48,71.6,226,16.43ZM41.17,197.91l21.59,57.89H19.58l21.59-57.89Z",
    fill: "#7f7f7f",
    stroke: "#707070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.09,133c-4.43,0-8.03,3.59-8.03,8.02v39.93c0,.13,0,.26,0,.39.06,1.24,7.41,124.04,128.92,124.04s128.86-122.8,128.92-124.04c0-.13,0-.26,0-.39v-39.93c0-4.43-3.59-8.02-8.03-8.02s-8.03,3.59-8.03,8.02v39.72c-.35,6.53-7.64,108.59-112.88,108.59s-112.51-102.16-112.88-108.6v-39.71c0-4.43-3.59-8.02-8.03-8.02Z",
    fill: "#7f7f7f",
    stroke: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.0ae554b7e83aadf0e8452fc1d7bbeb5e.svg";
export { ForwardRef as ReactComponent };